import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Transfer } from 'antd';

class ProfileDivisions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sourceKeysSelected: [],
            targetKeysSelected: [],
        };
    }

    handleChange = (nextTargetKeys, direction, moveKeys) => {
        const { dispatch, profile } = this.props;

        if (direction === 'right') {
            dispatch({
                type: 'CHANGE_USER_PROFILE_DIVISIONS_SAGA',
                payload: {
                    action: 'addDivisions',
                    userId: profile._id,
                    divisions: moveKeys,
                },
            });
        }

        dispatch({
            type: 'CHANGE_USER_PROFILE_DIVISIONS_SAGA',
            payload: {
                action: direction === 'right' ? 'addDivisions' : 'delDivisions',
                userId: profile._id,
                divisions: moveKeys,
            },
        });
    };

    handleSelectChange = (sourceKeysSelected, targetKeysSelected) => {
        this.setState({
            sourceKeysSelected,
            targetKeysSelected,
        });
    }

    render() {
        const { divisionsList, isLoading, profile } = this.props;
        const targetKeys = [];

        (divisionsList || []).forEach((division, idx) => {
            const exists = (profile.divisions || []).some(userDivision => userDivision._id === division._id);

            division.key = division._id;

            if (exists) {
                targetKeys.push(division._id);
            }
        });

        return (
            <Spin spinning={isLoading} tip="Divisions are updating...">
                <h5 style={{ paddingBottom: 8 }}>Divisions setting</h5>
                {
                    !isLoading && divisionsList && (
                        <Transfer
                            listStyle={{ width: '47%' }}
                            dataSource={divisionsList}
                            titles={['All Divisions', 'Existing Divisions']}
                            targetKeys={targetKeys}
                            selectedKeys={this.state.selectedKeys}
                            onChange={this.handleChange}
                            onSelectChange={this.handleSelectChange}
                            lazy={false}
                            render={item => item.name}
                        />
                    )
                }
            </Spin>
        );
    }
}

const mapStateToProps = (state) => {
    const { divisions: divisionsList } = state.UserManagement.User_profile.User_profile_table.options;
    const { loading: isLoading } = state.UserManagement.User_profile.User_profile_divisions;
    const { profile } = state.UserManagement.User_profile.User_profile_table;

    return { divisionsList, isLoading, profile };
};

export default connect(mapStateToProps)(ProfileDivisions);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/components/ProfileDivisions.js